import { useNavigate } from "react-router-dom";
import { Sparkles, ChevronLeft, ArrowRight, Camera, Wallet, Shirt, Store } from "lucide-react";

// AI Stylist landing — explains what the stylist does, then routes to /upload
// to begin the photo → style → budget → 4 outfits flow.
const STEPS = [
  { icon: Camera, title: "1. Snap a photo",   desc: "Front-facing full body. We use it to read your build + lighting." },
  { icon: Shirt,  title: "2. Pick a style",   desc: "Streetwear · Old Money · Luxury · Casual · Y2K · Athletic · Smart Casual · Techwear and more." },
  { icon: Wallet, title: "3. Set a budget",   desc: "A total cap in USD — every outfit lands under it." },
  { icon: Store,  title: "4. Get 4 outfits",  desc: "Safe Pick · Trending · Bold · Budget Maximizer — with real stores, online + local options." },
];

export default function StylistLandingScreen() {
  const navigate = useNavigate();
  return (
    <div className="screen with-nav fade-in" data-testid="stylist-landing-screen">
      <div className="top-bar">
        <button className="icon-btn" onClick={() => navigate("/home")} aria-label="Back" data-testid="stylist-back">
          <ChevronLeft size={18} />
        </button>
        <div className="logo-mark">AI STYLIST</div>
        <span className="premium-pill">FREE</span>
      </div>

      <div className="eyebrow" style={{ marginBottom: 8 }}>YOUR PERSONAL STYLIST</div>
      <h2 className="h1" style={{ fontSize: 30, marginBottom: 18, lineHeight: 1.12 }}>
        Four outfits.<br />
        <em className="serif" style={{ fontStyle: "italic", fontWeight: 300 }}>One photo. Two minutes.</em>
      </h2>
      <p className="body" style={{ marginTop: 0, marginBottom: 22, color: "var(--text-dim)" }}>
        Upload one photo. Choose a style and budget. We return four personalised outfits with real stores and shoppable links — online and local options where available.
      </p>

      <div className="stagger" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="tile" style={{ flexDirection: "row", alignItems: "center", textAlign: "left" }} data-testid={`stylist-step-${i + 1}`}>
              <div className="tile-icon"><Icon size={18} strokeWidth={1.7} /></div>
              <div style={{ flex: 1 }}>
                <div className="h3" style={{ color: "var(--text)" }}>{s.title}</div>
                <div className="tiny" style={{ marginTop: 4, color: "var(--text-faint)" }}>{s.desc}</div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        className="btn btn-gold"
        style={{ marginTop: 22, width: "100%", justifyContent: "center" }}
        onClick={() => navigate("/upload?source=gallery")}
        data-testid="stylist-start-btn"
      >
        <Sparkles size={14} /> Start the stylist
        <ArrowRight size={14} />
      </button>

      <p className="tiny" style={{ marginTop: 16, color: "var(--text-faint)", textAlign: "center" }}>
        Real product photos and direct purchase links roll out as our retailer integration goes live. For now, every fit ships with branded store search and price guidance.
      </p>
    </div>
  );
}
